// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "route-root" + "." + "7144c3c7" + ".chunk.css";
};